import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../../../environments/environment";


@Component({
  selector: 'app-preview-application-form',
  templateUrl: './preview-application-form.component.html',
  styleUrls: ['./preview-application-form.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PreviewApplicationFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('frame') frame!: ElementRef<HTMLIFrameElement>;
  locationCode!: string;
  offeringCode!: string;
  formState: string = 'preview';
  formCode!: string;
  embedKey!: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.locationCode = this.route.snapshot.queryParamMap.get('locationCode')!;
    this.offeringCode = this.route.snapshot.queryParamMap.get('offeringCode')!;
    this.embedKey = this.route.snapshot.queryParamMap.get('embedKey')!;
    this.formCode = this.route.snapshot.paramMap.get('formCode')!;
  }

  ngAfterViewInit() {
    const iframeDocument = this.frame.nativeElement.contentDocument || this.frame.nativeElement.contentWindow?.document;

    if (iframeDocument) {
      // Create a script element
      const script = iframeDocument.createElement('script');
      script.src = environment.apiAppForm;
      script.onload = () => {
        // Insert HTML only after the script has loaded
        this.insertHTML(iframeDocument);
      };

      // Append the script to the iframe document
      iframeDocument.head.appendChild(script);
    }
  }

  ngOnDestroy(): void {
    // Clean up script and custom element on destroy
    const container = this.frame.nativeElement;
    container.innerHTML = '';
  }

  insertHTML(iframeDocument: Document) {
    const htmlContent = `
      <nter-app-form location-code="${this.locationCode}"
                     offering-code="${this.offeringCode}"
                     embed-key="${this.embedKey}"
                     mode="${this.formState}"
                     code="${this.formCode}">
      </nter-app-form>
    `;

    // Create a container to hold the HTML
    const container = iframeDocument.createElement('div');
    container.innerHTML = htmlContent;

    // Append the container to the body of the iframe document
    iframeDocument.body.appendChild(container);
  }

  protected readonly environment = environment;
}
